import { InstructionDetails } from 'src/Components/Instructions/InstructionDetails';
import { FullScreenFormWrapper } from 'src/Containers/FullScreenFormWrapper';
import useFetchExportedInstruction from 'src/Hooks/Queries/useFetchExportedInstruction';

import { Props } from './ExportedInstructionWrapper.types';

const ExportedInstructionWrapper = ({ instructionId, token }: Props) => {
  const { data } = useFetchExportedInstruction({ token, instructionId });

  return (
    <FullScreenFormWrapper>
      {data && <InstructionDetails instruction={data} />}
    </FullScreenFormWrapper>
  );
};

export default ExportedInstructionWrapper;
